import { render, staticRenderFns } from "./MovementSystem.vue?vue&type=template&id=e2555b2c&"
import script from "./MovementSystem.vue?vue&type=script&lang=js&"
export * from "./MovementSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports